// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- packages that compile this from source (forms) have no vite/client, and a wildcard module cannot be imported
/// <reference path="../assets.d.ts" />
import { cn } from '../lib/cn'
import voleeMarkSrc from './volee-mark.png'

// The product's own mark, the striped V: `resources/icon-foreground.png` cropped to its ink.

export interface VoleeMarkProps {
  /** The image's alt text, already translated: the product's name. Empty is decorative. */
  label: string
  /** `md` is the shell's (header pill, head of the column); `lg` and `xl` stand a page's mark
   *  alone, above a card. */
  size?: 'md' | 'lg' | 'xl'
  /** Positioning only: the height is the size's. */
  className?: string
}

const SIZES = {
  md: 'h-(--size-brand-mark)',
  lg: 'h-(--size-brand-mark-lg)',
  xl: 'h-(--size-brand-mark-xl)',
} as const

export function VoleeMark({ label, size = 'md', className }: VoleeMarkProps) {
  return <img src={voleeMarkSrc} alt={label} className={cn(SIZES[size], 'w-auto', className)} />
}
